// src/reducers/gerenciadorPrecos/dataPointsExhibitionType.ts
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../@types/RootState';

const initialState = {
  datapointExhibitionType: 'PRODUCT' as 'PRODUCT' | 'FAMILY' | 'PRODUCT_CLUSTER' | 'PRODUCT_CLUSTER_FAMILY',
  getFamilyModalIsOpen: false,
  getClusterStoreModalIsOpen: false,
  getProductFamilyClusterModalIsOpen: false,
  getStoreFamilyClusterModalIsOpen: false,
};

export type DatapointExhibitionTypeState = typeof initialState;

const slice = createSlice({
  name: 'gerenciadorPrecos/dataPointsExhibitionType',
  initialState,
  reducers: {
    SET_DATA_POINTS_EXHIBITION_TYPE: (state, { payload }: PayloadAction<'PRODUCT' | 'FAMILY' | 'PRODUCT_CLUSTER' | 'PRODUCT_CLUSTER_FAMILY'>) => {
      state.datapointExhibitionType = payload;
    },
    SET_GET_FAMILY_MODAL_IS_OPEN: (state, { payload }: PayloadAction<boolean>) => {
      state.getFamilyModalIsOpen = payload;
    },
    SET_GET_CLUSTER_STORE_MODAL_IS_OPEN: (state, { payload }: PayloadAction<boolean>) => {
      state.getClusterStoreModalIsOpen = payload;
    },
    SET_GET_PRODUCT_FAMILY_CLUSTER_MODAL_IS_OPEN: (state, { payload }: PayloadAction<boolean>) => {
      state.getProductFamilyClusterModalIsOpen = payload;
    },
    SET_GET_STORE_FAMILY_CLUSTER_MODAL_IS_OPEN: (state, { payload }: PayloadAction<boolean>) => {
      state.getStoreFamilyClusterModalIsOpen = payload;
    },
  },
});

const selectorDataPointsExhibitionType = (state: RootState) => {
  return state.datapointExhibitionType.datapointExhibitionType;
};

const selectorGetFamilyModalIsOpen = (state: RootState) => {
  return state.datapointExhibitionType.getFamilyModalIsOpen;
};

const selectorGetClusterStoreModalIsOpen = (state: RootState) => {
  return state.datapointExhibitionType.getClusterStoreModalIsOpen;
};

const selectorGetProductFamilyClusterModalIsOpen = (state: RootState) => {
  return state.datapointExhibitionType.getProductFamilyClusterModalIsOpen;
};

const selectorGetStoreFamilyClusterModalIsOpen = (state: RootState) => {
  return state.datapointExhibitionType.getStoreFamilyClusterModalIsOpen;
};

export const {
  SET_DATA_POINTS_EXHIBITION_TYPE,
  SET_GET_FAMILY_MODAL_IS_OPEN,
  SET_GET_CLUSTER_STORE_MODAL_IS_OPEN,
  SET_GET_PRODUCT_FAMILY_CLUSTER_MODAL_IS_OPEN,
  SET_GET_STORE_FAMILY_CLUSTER_MODAL_IS_OPEN,
} = slice.actions;

export {
  selectorDataPointsExhibitionType,
  selectorGetClusterStoreModalIsOpen,
  selectorGetFamilyModalIsOpen,
  selectorGetProductFamilyClusterModalIsOpen,
  selectorGetStoreFamilyClusterModalIsOpen,
};

export default slice.reducer;
